__turbopack_context__.v({
  "dashboard-status": "qr-code-modal-module-scss-module__8642bG__dashboard-status",
  "modal-body": "qr-code-modal-module-scss-module__8642bG__modal-body",
  "modal-content": "qr-code-modal-module-scss-module__8642bG__modal-content",
  "plan-details": "qr-code-modal-module-scss-module__8642bG__plan-details",
  "qr-code-details": "qr-code-modal-module-scss-module__8642bG__qr-code-details",
  "user-info": "qr-code-modal-module-scss-module__8642bG__user-info",
});
